import { GenderService } from "../../services/models/gender";
const moduleGender = {
	namespaced: true,
	state: {
		genders: [],
		loading: false,
	},
	getters: {
		getGenders(state) {
			return state.genders;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadGenders(state, genders) {
			state.genders = genders;
		}
	},
	actions: {
		async loadGenders({ commit, state }) {
			state.loading = true;
			let genders = await GenderService.getAll();
			commit("loadGenders", genders);
			state.loading = false;
		}
	}
}

export default moduleGender;